import React from 'react'

interface VehicleCountProps {
  count: number
  vehicleGroup?: string
}

export const VehicleCount: React.FunctionComponent<VehicleCountProps> = ({
  count,
  vehicleGroup,
}) => (
  <>
    {count}
    {' ✕ '}
    {vehicleGroup}
  </>
)
